"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("circle", { cx: "24", cy: "24", r: "6" }),
  React.createElement("circle", { cx: "42", cy: "24", r: "6" }),
  React.createElement("circle", { cx: "6", cy: "24", r: "6" })
);

